<div class="container" *ngIf="!closePopup">
    <div>
      <div class="fixed-bottom w-100 bg-dark text-white" (hidden)="deny()" style="position: relative;">
        <div class="text-start p-4 d-flex flex-column">
          <h4 class="veryLargeText">Cookies</h4>
          <p class="smallerText text-start">
            We use cookies to provide you with an optimal website experience. By continuing to use the website, you agree to the use of cookies.
            You can learn more about the cookies we use here: <a [routerLink]="null"><b>Privacy Policy</b></a>
          </p>
          <div class="text-end">
            <button pButton (click)="deny()" label="Deny" class="btn p-button-outlined p-button-secondary p-button-raised">
            </button>
            <button pButton (click)="accept()" label="Accept" class="btn p-button-outlined p-button-raised">
            </button>
        </div>
        </div>
    </div>
    </div>
  </div>